// Store download links for the public /download page (served at flexplay.club/download).
//
// Supplied at build time (see Dockerfile ARGs + docker-compose build.args):
//   REACT_APP_APP_STORE_URL  -> https://apps.apple.com/app/id6782097523
//   REACT_APP_PLAY_STORE_URL -> https://play.google.com/store/apps/details?id=club.flexplay.app
//
// Uygulamalar yayında — gerçek store URL'leri code fallback olarak gömülü. Build-time
// env (Dockerfile ARGs + docker-compose build.args) bu default'u ezer; DOWNLOAD_FALLBACK_URL
// yine son çare. CRA REACT_APP_* build-time inline edilir → değişiklikte image rebuild şart.
export const APP_STORE_URL = process.env.REACT_APP_APP_STORE_URL || "https://apps.apple.com/app/id6782097523";
export const PLAY_STORE_URL = process.env.REACT_APP_PLAY_STORE_URL || "https://play.google.com/store/apps/details?id=club.flexplay.app";
export const DOWNLOAD_FALLBACK_URL = "https://flexplay.club";
